import * as actions from '../actionTypes'

const initialState = {
  addressTypeChange: {
    nsHealthCard: false,
    driverLicence: false,
    vehiclePermit: false,
    registeredByName: false,
    jointlyRegistered: false,
    registeredBusiness: false
  },
  currentAddress: {
    streetAddress: '',
    apartment: '',
    city: '',
    postalCode: '',
    medavieDifferentAddress: null,
    currentAddressSameMedavie: true,
  },
  addressesToChange: {
    homeAddress: true,
    mailingAddress: false
  },

  personalInformation: {
    editNSIdentifierNumber: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    nsHealthCardNumber: '',
    masterNumber: '',
    masterNumberDOB: '',
    houseHoldMembers: [],
    prevPersonalInformation: null
  },
  jointlyOwnedVehicleInformation: {
    editMasterNumber: '',
    name: '',
    jointMasterNumber: '',
    vehicles: []
  },
  businessVehicleInformation: {
    editMasterNumber: '',
    businessName: '',
    masterNumber: '',
    businessVehicles: []
  },
  newAddressEffective: null,
  newAddress: {
    streetAddress: '',
    apartment: '',
    city: '',
    postalCode: '',
    mailingAddressSame: true,
    mailingAddress: {
      streetAddress: '',
      apartment: '',
      city: '',
      postalCode: ''
    }
  },
  contactInformation: {
    phoneNumber: '',
    email: '',
    name: null,
  }
}

export const initialMedavieDifferentAddress = {
  streetAddress: '',
  apartment: '',
  city: '',
  postalCode: '',
};

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.LIST_ADD: {
      if (action.payload.listType === 'personalInformation') {
        const houseHoldMembers = ensureNoHouseholdDuplicates(state.addressTypeChange.nsHealthCard, state.personalInformation.houseHoldMembers, action.payload.data)
        return {
          ...state,
          personalInformation: {
            ...state.personalInformation,
            houseHoldMembers
            // houseHoldMembers: [...state.personalInformation.houseHoldMembers, action.payload.data],
          }
        }
      }
      else if (action.payload.listType === 'jointlyOwnedVehicleInformation') {
        const vehicles = ensureNoJointVehicleDuplicates(state.jointlyOwnedVehicleInformation.vehicles, action.payload.data)
        return {
          ...state,
          jointlyOwnedVehicleInformation: {
            ...state.jointlyOwnedVehicleInformation,
            vehicles
            // vehicles: [...state.jointlyOwnedVehicleInformation.vehicles, action.payload.data],
          }
        }
      }
      else if (action.payload.listType === 'businessVehicleInformation') {
        const businessVehicles = ensureNoBusinessVehicleDuplicates(state.businessVehicleInformation.businessVehicles, action.payload.data);
        return {
          ...state,
          businessVehicleInformation: {
            ...state.businessVehicleInformation,
            businessVehicles
            // businessVehicles: [...state.businessVehicleInformation.businessVehicles, action.payload.data],
          }
        }
      }
      break;
    }
    case actions.SET_EDIT_NS_IDENTIFIER_NUMBER:
      const member = state.personalInformation.houseHoldMembers.find((hMember) => hMember.nsHealthCardNumber === action.payload.data || hMember.masterNumber === action.payload.data)
      const masterNumberDOBArr = member?.dateOfBirth.split("-");
      return {
        ...state,
        personalInformation: {
          ...state.personalInformation,
          editNSIdentifierNumber: action.payload.data,
          firstName: member?.firstName ?? '',
          lastName: member?.lastName ?? '',
          dateOfBirth: member?.dateOfBirth ?? '',
          nsHealthCardNumber: member?.nsHealthCardNumber ?? '',
          masterNumber: member?.masterNumber ?? '',
          masterNumberDOB: masterNumberDOBArr ? `${masterNumberDOBArr[2]}${masterNumberDOBArr[1]}${masterNumberDOBArr[0].substr(-2)}` : ''
        }
      }
    case actions.SET_EDIT_JOINT_MASTER_NUMBER:
      const { editMasterNumber } = state.jointlyOwnedVehicleInformation
      const vehicle = state.jointlyOwnedVehicleInformation.vehicles.find((vehicle) => vehicle.jointMasterNumber === editMasterNumber) ?? state.jointlyOwnedVehicleInformation.vehicles[0];
      return {
        ...state,
        jointlyOwnedVehicleInformation: {
          ...state.jointlyOwnedVehicleInformation,
          editMasterNumber: vehicle?.jointMasterNumber ?? '',
          name: vehicle?.name ?? '',
          jointMasterNumber: vehicle?.jointMasterNumber ?? '',
        }
      }
    case actions.SET_EDIT_BUSINESS_MASTER_NUMBER:
      const businessEditMasterNumber = state.businessVehicleInformation.editMasterNumber
      const businessVehicle = state.businessVehicleInformation.businessVehicles.find((vehicle) => vehicle.masterNumber === businessEditMasterNumber)
      return {
        ...state,
        businessVehicleInformation: {
          ...state.businessVehicleInformation,
          editMasterNumber: businessEditMasterNumber,
          businessName: businessVehicle?.businessName ?? '',
          masterNumber: businessVehicle?.masterNumber ?? '',
        }
      }
    case actions.LIST_EDIT: {
      if (action.payload.listType === 'personalInformation') {

        return {
          ...state,
          personalInformation: {
            ...state.personalInformation,
            houseHoldMembers: state.personalInformation.houseHoldMembers.map((personInfo) =>
              (personInfo.nsHealthCardNumber === state.personalInformation.editNSIdentifierNumber ? action.payload.data : personInfo)),
          }
        }
      }
      else if (action.payload.listType === 'jointlyOwnedVehicleInformation') {

        return {
          ...state,
          jointlyOwnedVehicleInformation: {
            ...state.jointlyOwnedVehicleInformation,
            vehicles: state.jointlyOwnedVehicleInformation.vehicles.map((vehicleInfo) =>
              (vehicleInfo.jointMasterNumber === state.jointlyOwnedVehicleInformation.editMasterNumber ? action.payload.data : vehicleInfo)),
          }
        }
      }
      else if (action.payload.listType === 'businessVehicleInformation') {
        return {
          ...state,
          businessVehicleInformation: {
            ...state.businessVehicleInformation,
            businessVehicles: state.businessVehicleInformation.businessVehicles.map((vehicleInfo) =>
              (vehicleInfo.masterNumber === state.businessVehicleInformation.editMasterNumber ? action.payload.data : vehicleInfo)),
          }
        }
      }
      break;
    }
    case actions.LIST_DELETE: {
      if (action.payload.listType === 'personalInformation') {
        const houseHoldMembers = state.personalInformation.houseHoldMembers.filter((personInfo) => personInfo.nsHealthCardNumber !== action.payload.value && personInfo.masterNumber !== action.payload.value);
        const newEditHouseholdMember = action.payload.value === state.personalInformation.editNSIdentifierNumber ? houseHoldMembers[0] : state.personalInformation.editNSIdentifierNumber
        return {
          ...state,
          personalInformation: {
            ...state.personalInformation,
            houseHoldMembers,
            editNSIdentifierNumber: newEditHouseholdMember
          }
        }
      }
      else if (action.payload.listType === 'jointlyOwnedVehicleInformation') {
        const jointVehicles = state.jointlyOwnedVehicleInformation.vehicles.filter((vehicleInfo) => vehicleInfo.jointMasterNumber !== action.payload.value);
        const newEditJointMasterNumber = action.payload.value === state.jointlyOwnedVehicleInformation.editMasterNumber ? jointVehicles[0] : state.jointlyOwnedVehicleInformation.editMasterNumber

        return {
          ...state,
          jointlyOwnedVehicleInformation: {
            ...state.jointlyOwnedVehicleInformation,
            vehicles: jointVehicles,
            editMasterNumber: newEditJointMasterNumber ?? ''
          }
        }
      }
      else if (action.payload.listType === 'businessVehicleInformation') {
        const businessVehicles = state.businessVehicleInformation.businessVehicles.filter((vehicleInfo) => vehicleInfo.masterNumber !== action.payload.value);
        const newEditBusinessMasterNumber = action.payload.value === state.businessVehicleInformation.editMasterNumber ? businessVehicles[0] : state.businessVehicleInformation.editMasterNumber

        return {
          ...state,
          businessVehicleInformation: {
            ...state.businessVehicleInformation,
            businessVehicles,
            editMasterNumber: newEditBusinessMasterNumber
          }
        }
      }
      break;
    }
    case actions.LIST_CLEAR: {
      if (action.payload.listType === 'personalInformation') {
        const { nsHealthCardNumber, masterNumber, editNSIdentifierNumber } = state.personalInformation;
        const newEditNSIdentifierNumber = nsHealthCardNumber || masterNumber || editNSIdentifierNumber;
        return {
          ...state,
          personalInformation: {
            ...state.personalInformation,
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            nsHealthCardNumber: '',
            masterNumber: '',
            editNSIdentifierNumber: newEditNSIdentifierNumber
          }
        }
      }
      else if (action.payload.listType === 'jointlyOwnedVehicleInformation') {
        const jointEditMasterNumber = state.jointlyOwnedVehicleInformation.jointMasterNumber || state.jointlyOwnedVehicleInformation.editMasterNumber
        return {
          ...state,
          jointlyOwnedVehicleInformation: {
            ...state.jointlyOwnedVehicleInformation,
            name: '',
            jointMasterNumber: '',
            editMasterNumber: jointEditMasterNumber
          }
        }
      }
      else if (action.payload.listType === 'businessVehicleInformation') {
        const editMasterNumber = state.businessVehicleInformation.masterNumber || state.businessVehicleInformation.editMasterNumber
        return {
          ...state,
          businessVehicleInformation: {
            ...state.businessVehicleInformation,
            businessName: '',
            masterNumber: '',
            editMasterNumber
          }
        }
      }
      break;
    }
    case actions.CHANGE_OBJECT_PROPERTY: {
      return {
        ...state,
        [action.payload.object]: {
          ...state[action.payload.object],
          [action.payload.field]: action.payload.value
        }
      }
    }
    case actions.SET_NEW_ADDRESS_MAILING_ADDRESS_SAME:
      return {
        ...state,
        newAddress: {
          ...state.newAddress,
          mailingAddressSame: action.payload
        }
      }
    case actions.SET_NEW_MAILING_ADDRESS_PROPERTY:
      return {
        ...state,
        newAddress: {
          ...state.newAddress,
          mailingAddress: {
            ...state.newAddress.mailingAddress,
            [action.payload.property]: action.payload.value
          }
        }
      }
    case actions.SET_CURRENT_ADDRESS_MEDAVIE_DIFFERENT:
      return {
        ...state,
        currentAddress: {
          ...state.currentAddress,
          medavieDifferentAddress: {
            ...(state.currentAddress.medavieDifferentAddress ?? {}),
            [action.payload.property]: action.payload.value
          }
        }
      }
    case actions.CURRENT_ADDRESS_SAME_MEDAVIE: {
      const medavieDifferentAddress = !action.payload.value ? { ...initialMedavieDifferentAddress } : undefined;
      return {
        ...state,
        currentAddress: {
          ...state.currentAddress,
          currentAddressSameMedavie: action.payload.value,
          medavieDifferentAddress
        }
      }
    }
    case actions.CLEAR_APP_DATA:
      const { addressTypeChange } = state;
      return { ...initialState, addressTypeChange }
    case actions.CLEAR_ALL: {
      return { ...initialState }
    }
    case 'SELECT_DATE':
      return {
        ...state,
        newAddressEffective: action.payload
      }
    default: {
      return state
    }
  }
}
export default AppReducer

export const isSameMember = (nsHealthCard, a, b) => {
  if (nsHealthCard) {
    return a.nsHealthCardNumber === b.nsHealthCardNumber
  } else {
    return (a.masterNumber && a.masterNumber === b.masterNumber)
  }
}

const ensureNoHouseholdDuplicates = (nsHealthCard, originalHouseholdMembers, newHouseholdMember) => {
  // const isSameMember = (a, b) => (a.nsHealthCardNumber && a.nsHealthCardNumber === b.nsHealthCardNumber) || (a.masterNumber && a.masterNumber === b.masterNumber);
  const foundDuplicate = originalHouseholdMembers.find((member) => isSameMember(nsHealthCard, member, newHouseholdMember));
  return foundDuplicate ? [...originalHouseholdMembers] : [...originalHouseholdMembers, newHouseholdMember];
}

const ensureNoJointVehicleDuplicates = (originalJointVehicles, newJointVehicles) => {
  const isSameMember = (a, b) => a.jointMasterNumber === b.jointMasterNumber;
  const foundDuplicate = originalJointVehicles.find((vehicle) => isSameMember(vehicle, newJointVehicles));
  return foundDuplicate ? [...originalJointVehicles] : [...originalJointVehicles, newJointVehicles];
}

const ensureNoBusinessVehicleDuplicates = (originalBusinessVehicles, newBusinessVehicles) => {
  const isSameMember = (a, b) => a.masterNumber === b.masterNumber;
  const foundDuplicate = originalBusinessVehicles.find((vehicle) => isSameMember(vehicle, newBusinessVehicles));
  return foundDuplicate ? [...originalBusinessVehicles] : [...originalBusinessVehicles, newBusinessVehicles];
}

export const findDuplicateMasterNumber = (masterNumber, houseHoldMembers, jointVehicles, businessVehicles) => {

  if (!masterNumber) {
    return false
  }
  return (houseHoldMembers.find((member) => masterNumber === member.masterNumber) ||
    jointVehicles.find((vehicle) => vehicle.jointMasterNumber === masterNumber) ||
    businessVehicles.find((vehicle) => vehicle.masterNumber === masterNumber)
  )
}

export const getNSIdentifierNumber = ({ nsHealthCard, driverLicence, nsHealthCardNumber, masterNumber }) => {
  switch (true) {
    case nsHealthCard:
      return nsHealthCardNumber;
    case driverLicence:
      return masterNumber;
    default:
      return nsHealthCardNumber;
  }
}